import React, { useRef } from 'react'
import { CloseIcon, SearchIcon } from '../iconSet/IconSet'
import { RestoreByIdPropsTypes } from './PopupTypes'

const RestoreById = (props: RestoreByIdPropsTypes) => {

    const idRef = useRef<HTMLInputElement | null>(null)

    const handleAddClick = () => {
        if(idRef.current && props.function){
            props.function(idRef.current.value)
            props.setWindowState(false)
        }
    }

    const handleCloseClick = () => {
        props.setWindowState(false)
    }

    return (
        <div className={`workflow-popup`}>
            <div className={`workflow-popup-wrapper`} style={{width: `20rem`}}>
                <div className={`title`}>
                    <span>Restore by id</span>
                    <CloseIcon width='1.2rem' color='var(--color-main-red)' onClick={(e) => props.setWindowState(false)}/>
                </div>
                <div className={`data-wrapper`} style={{display: 'flex', alignItems: 'center'}}>
                    <div className={`input-wrapper`}>
                        <i><SearchIcon color='var(--color-main-white)' width='1.2rem' /></i>
                        <input type="text" placeholder='Enter id' ref={idRef}/>
                    </div>
                </div>
                <div className={`button-wrapper`} style={{gridArea: 'buttons'}}>
                    <div className={`left-side`}>
                        <button className={`button-normal`} onClick={(e) => handleAddClick()}>add</button>
                    </div>
                    <div className={`right-side`}>
                        <button className={`button-normal`} onClick={(e) => handleCloseClick()}>close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RestoreById